import React from 'react';
import dayjs from 'dayjs';
import {
  Box,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';

import { Page, EnhancedTable } from 'components';

const formatDateTime = (row, col) => dayjs(row[col]).format('YYYY-MM-DD HH:mm:ss');
const changeLabels = {ad_slot_name: '广告位'};
const formatContent = (row, col) => (
  <Box sx={{
    '& > *:not(:last-child)::after': { content: '", "' },
  }}>
  {Object.entries(row[col] || {}).map(([k, v]) => Array.isArray(v) && v.length === 2 ?
    <Tooltip key={k} title={v.map(a => a || '""').join(' → ')}>{changeLabels[k] || k}</Tooltip>
    :
    <Typography key={k} component="span" sx={{fontSize: 'inherit'}}>{changeLabels[k] || k}</Typography>
  )}
  </Box>
);

const columns = [
  { name: 'job', sx: { width: '5%' } },
  { name: 'name', sx: { width: '17%' } },
  { name: 'date', format: formatDateTime, sx: { width: '12%' } },
  { name: 'user', sx: { width: '16%' } },
  { name: 'content', format: formatContent, sx: { width: '50%' } },
];

const Changelist = () => {
  return (
    <Page title='Job Changelist'>
      <Paper sx={{p: 1, pb: 0, m: 2, mt: 1}}>
        <EnhancedTable
          stickyHeader
          columns={columns}
          dataUrl="/jobs/changelist"
          dense={true}
          multiPage={true}
          styles={{tableLayout: 'fixed'}}
        />
      </Paper>
    </Page>
  );
};

export default Changelist;
